import {AssetsRequestParams} from "../../../infrastructure/models/params/assets-request-params";

export class CheckMarkRequestParams extends AssetsRequestParams {
  constructor(size: Number) {
    super(size, size);

    this.resourceName = this.resourceName + `/VIcon`;
  }
}